import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckboxComponent } from '@shared/form-elements/checkbox/checkbox.component';
import { CustomValidatorsService } from '@shared/form-elements/custom-validators/custom-validators.service';
import { FilterButtonComponent } from '@shared/form-elements/filter-button/filter-button.component';
import { HandleInvalidOnSubmitDirective } from '@shared/form-elements/form-helpers/handle-invalid-on-submit.directive';
import { InputEmailComponent } from '@shared/form-elements/input/input-email/input-email.component';
import { InputPhoneComponent } from '@shared/form-elements/input/input-phone/input-phone.component';
import { InputStreetAddressComponent } from '@shared/form-elements/input/input-street-address/input-street-address.component';
import { InputZipcodeComponent } from '@shared/form-elements/input/input-zipcode/input-zipcode.component';
import { InputComponent } from '@shared/form-elements/input/input/input.component';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { FirstKeyPipe } from '@shared/form-elements/pipes/first-key.pipe';
import { ValidationErrorMessagePipe } from '@shared/form-elements/pipes/validation-error-message.pipe';
import { RadioComponent } from '@shared/form-elements/radio/radio.component';
import { SelectComponent } from '@shared/form-elements/select/select.component';
import { SelectionComponent } from '@shared/form-elements/selection/selection.component';
import { SharedModule } from '@shared/shared.module';

import { ErrorBoxComponent } from './error-box/error-box.component';
import { InputBasicComponent } from './input/input-basic/input-basic.component';
import { InputBirthDateComponent } from './input/input-birth-date/input-birth-date.component';
import { GenderTranslationKeyPipe } from './pipes/gender-translation-key.pipe';
import { QuantityComponent } from './quantity/quantity.component';
import { InputTextareaComponent } from './input/input-textarea/input-textarea.component';
import { SelectionThumbComponent } from '@shared/form-elements/selection-thumb/selection-thumb.component';

@NgModule({
    imports: [SharedModule, CommonModule, RadioComponent,
        CheckboxComponent,
        SelectionComponent,
        InputPhoneComponent,
        InputEmailComponent,
        InputComponent,
        FirstKeyPipe,
        ValidationErrorMessagePipe,
        ControlToKeyNamePipe,
        InputZipcodeComponent,
        InputStreetAddressComponent,
        FilterButtonComponent,
        HandleInvalidOnSubmitDirective,
        SelectComponent,
        ErrorBoxComponent,
        QuantityComponent,
        InputBasicComponent,
        InputBirthDateComponent,
        GenderTranslationKeyPipe,
        InputTextareaComponent,
        SelectionThumbComponent],
    exports: [
        RadioComponent,
        CheckboxComponent,
        SelectionComponent,
        InputPhoneComponent,
        InputEmailComponent,
        InputComponent,
        FirstKeyPipe,
        ValidationErrorMessagePipe,
        ControlToKeyNamePipe,
        InputZipcodeComponent,
        InputStreetAddressComponent,
        FilterButtonComponent,
        HandleInvalidOnSubmitDirective,
        SelectComponent,
        ErrorBoxComponent,
        QuantityComponent,
        InputBasicComponent,
        InputBirthDateComponent,
        GenderTranslationKeyPipe,
        InputTextareaComponent,
        SelectionThumbComponent
    ],
    providers: [CustomValidatorsService]
})
export class FormElementsModule {}
